/* This file is autogenerated, see readme.md for instructions */
import UndoSvgIcon from '@bloomreach/banana-theme/icons/undo.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const UndoIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <UndoSvgIcon />
    </Icon>
  );
});

UndoIcon.displayName = 'UndoIcon';

export default UndoIcon;
